<div class="container-gallery">
  <p-galleria
  [value]="getPictures()"
  [responsiveOptions]="responsiveOptions"
  [numVisible]="5"
  [thumbnailsPosition]="position"
  *ngIf="isMobile===false"
  >
  <ng-template pTemplate="item" let-item>
    <div
      style="
      display:flex;
      justify-content: center;
      align-items: center;
      height:430px;
      padding:0 1em;
      "
    >
    <img [src]="completeUrl(item.url)"
    (click)="imageClick(item.id)"
    style="
      object-fit: cover;
      width: 100%;
      height: 100%;
    " />
  </div>

  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div
      class="grid grid-nogutter justify-content-center"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 80px;
        background: #eaeaea;
        border-radius: 4px;
        overflow: hidden;
      "
      >
      <img [src]="completeUrl(item.url)"
      (click)="imageClick(item.id)"
        style="width: auto;"
        style="height: 100px;"

      />
    </div>
  </ng-template>
</p-galleria>
<p-galleria
  [value]="getPictures()"
  [responsiveOptions]="responsiveOptions"
  [numVisible]="5"
  *ngIf="isMobile===true"
  >
  <ng-template pTemplate="item" let-item>
    <div
      style="
      display:flex;
      justify-content: center;
      align-items: center;
      height:430px;
      padding:0 1em;
      "
    >
    <img [src]="completeUrl(item.url)"
    (click)="imageClick(item.id)"
    style="
      object-fit: cover;
      width: 100%;
      height: 100%;
    " />
  </div>

  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div
      class="grid grid-nogutter justify-content-center"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 80px;
        background: #eaeaea;
        border-radius: 4px;
        overflow: hidden;
      "
      >
      <img [src]="completeUrl(item.url)"
      (click)="imageClick(item.id)"
        style="width: auto;"
        style="height: 100px;"

      />
    </div>
  </ng-template>
</p-galleria>

<p-galleria   [value]="getPictures()" class="galleria-full"
[(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
[numVisible]="1"
[(activeIndex)]="activeIndex"
[circular]="true"
[fullScreen]="true"
[showItemNavigators]="true"
[showThumbnails]="false">
<ng-template pTemplate="item" let-item>
  <div class="image-container">
    <img [src]="completeUrl(item.url)" style="width: 100%; display: block;" class="gallery-image" />
  </div>
</ng-template>
</p-galleria>
</div>
